@import "../../palette";

div#_FiscalpopDialogConnect {
    display: grid;
    max-width: 95vw;
    width: 450px;
    row-gap: 1em;
    div._header {
        padding: 1em 1em;
        display: grid;
        background-color: #f0f0f8;
        border-bottom: solid 1px #dcdcea;
        h4 {
            font-size: 1.25em;
            margin: 0px;
            font-weight: 600;
        }
    }
    div._body {
        display: grid;
        padding: 1em 1.75em 2em;
        p {
            font-size: 0.85em;
            font-weight: 500;
        }
        // Dialog flow components
        div.platformChooser {
            display: grid;
            column-gap: 1em;
            grid-template-columns: 1fr 1fr;
            row-gap: 1em;
            h3 {
                margin: 0px 0px 0em 0px;
                grid-column: 1 / 3;
                text-align: center;
                font-size: 0.95em;
                font-weight: 600;
            }
            div._plaformOption {
                display: grid;
                padding: 1em;
                height: 96px;
                width: 110px;
                row-gap: 0.5em;
                grid-template-rows: 60px 20px;
                opacity: 0.725;
                cursor: pointer;
                border-radius: 6px;
                border: solid 1px transparent;
                background-color: white;
                transition: all ease-in-out 150ms;

                justify-self: center;
                img {
                    max-width: 55px;
                    max-height: 55px;
                    justify-self: center;
                    align-self: center;
                }
                h2 {
                    margin: 0px;
                    font-size: .85em;
                    font-weight: 600;
                    text-align: center;
                    justify-self: center;
                    align-self: center;
                }
                &:hover {
                    opacity: 1;
                    background-color: rgb(250, 250, 253);
                    border: solid 1px rgb(220, 222, 224);
                }
            }
        }
        div.accChooserWrap{
            display: grid;
            row-gap: 1em;
            &.success {
                & > i {
                    font-size: 5em;
                    justify-self: center;
                    color: $primary;
                    margin-bottom: 12px;
                }
                & > p{
                    font-size: 1em;
                    font-weight: 400;
                }
            }
        }
        div.existingAccountChooser{
            display: grid;
            column-gap: 1em;
            grid-template-columns: 1fr 1fr;
            row-gap: 1em;
            align-self: center;
            h3 {
                margin: 0px 0px 0em 0px;
                grid-column: 1 / 3;
                text-align: center;
                font-size: 0.95em;
                font-weight: 600;
            }
            div._rfcOption{
                display: grid;
                justify-self: center;
                align-self: center;
                row-gap: .5em;
                grid-template-rows: 1fr 30px;
                padding: 1em;
                height: 96px;
                opacity: 0.725;
                cursor: pointer;
                border-radius: 6px;
                border: solid 1px transparent;
                h2,p {
                    text-align: center;
                }
                &:hover {
                    opacity: 1;
                    background-color: rgb(250, 250, 253);
                    border: solid 1px rgb(220, 222, 224);
                }
                &._selected{
                    opacity: 1;
                    background-color: rgb(250, 250, 253);
                    border: solid 1px rgb(220, 222, 224);
                }
            }
        }
        div.emailInputChooser{
            display: grid;

        }
        div.rfcSpawnningChooser{
            display: grid;
            column-gap: 1em;
            grid-template-columns: 1fr 1fr;
            row-gap: 1em;
            align-self: center;
            h3 {
                margin: 0px 0px 0em 0px;
                grid-column: 1 / 3;
                text-align: center;
                font-size: 0.95em;
                font-weight: 600;
            }
            div._rfcOption{
                display: grid;
                align-self: center;
                justify-self: center;
                padding: 1em;
                height: 126px;
                opacity: 0.725;
                cursor: pointer;
                border-radius: 6px;
                border: solid 1px transparent;
                h2, p {
                    text-align: center;
                }
                &:hover {
                    opacity: 1;
                    background-color: rgb(250, 250, 253);
                    border: solid 1px rgb(220, 222, 224);
                }
                
            }
        }
        div.accountForging{
            display: grid;
            column-gap: 1em;
            grid-template-columns: 1fr;
            row-gap: 1em;
            align-self: center;
            h3 {
                margin: 0px 0px 0em 0px;
                text-align: center;
                font-size: 0.95em;
                font-weight: 600;
            }
            div.extraData{
                display: none;
                
                h2{
                    margin: 0px 0px 12px;
                }
                p{
                    margin: 0px 0px 18px;
                }
                button{
                    margin-top: 1em;
                    //justify-self: end;
                }
            }
            &.amazon{
                div.extraData{
                    &.isAmazon{
                        display: grid;
                    }
                }
            }
            &.claroshop{
                div.extraData{
                    &.isClaroshop{
                        display: grid;
                    }
                }
            }
            &.izettle{
                div.extraData{
                    &.isZettle{
                        display: grid;
                    }
                }
            }
            &.fiscalpop{
                div.extraData{
                    &.isFiscalpop{
                        display: grid;
                    }
                }
            }
            &.mercadolibre{
                div.extraData{
                    &.isMercadoLibre{
                        display: grid;
                    }
                }
            }
            &.tiendanube{
                div.extraData{
                    &.isTiendaNube{
                        display: grid;
                    }
                }
            }
        }

        // Step management display
        div{
            &.platformChooser, &.accChooserWrap, &.accountForging{
                grid-column: 1 / 2;
                grid-row: 1 / 2;
            }
        }
    
        &.step_0{
            div.platformChooser{
                display: grid;
            }
            div.accChooserWrap,  div.accountForging{
                display: none;
            }
        }
        &.step_1{
            div.accChooserWrap{
                display: grid;
            }
            div.platformChooser, div.accountForging{
                display: none;
            }
        }
        &.step_2{
            div.accountForging{
                display: grid;
            }
            div.platformChooser, div.accChooserWrap{
                display: none;
            }
        }
    }
}
